<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="lastname"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-personal-lastname">
                  {{ $t('form.lastname') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="lastname"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-personal-lastname"
                  :placeholder="$t('form.lastname')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="firstname"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-personal-firstname">
                  {{ $t('form.firstname') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="firstname"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-personal-firstname"
                  :placeholder="$t('form.firstname')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="email"
                rules="email|required"
                v-slot="{ errors }"
                mode="lazy"
              >
                <label for="signup-personal-email">
                  {{ $t('form.email') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-personal-email"
                  :placeholder="$t('form.email')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="phone"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="phone">
                  {{ $t('form.phone') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="phone"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="phone"
                  :placeholder="$t('form.phone')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>
                {{ $t('form.gender') }}
                <sup class="text-danger">*</sup>
              </label>
              <div>
                <div
                  class="custom-control custom-control_light custom-radio custom-control-inline"
                >
                  <validation-provider
                    name="gender"
                    rules="oneOf:1,2"
                    v-slot="{ errors }"
                  >
                    <input
                      type="radio"
                      id="customRadioInline1"
                      v-model="gender"
                      value="1"
                      :class="{ 'is-invalid': errors.length }"
                      name="customRadioInline1"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="customRadioInline1"
                    >
                      {{ $t('form.mr') }}</label
                    >
                  </validation-provider>
                </div>
                <div
                  class="custom-control custom-control_light custom-radio custom-control-inline"
                >
                  <validation-provider
                    name="gender"
                    rules="oneOf:1,2"
                    v-slot="{ errors }"
                  >
                    <input
                      type="radio"
                      id="customRadioInline2"
                      v-model="gender"
                      value="2"
                      :class="{ 'is-invalid': errors.length }"
                      name="customRadioInline2"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="customRadioInline2"
                    >
                      {{ $t('form.mrs') }}</label
                    >
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <validation-provider
                name="birthday"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="birthday">
                  {{ $t('form.birthday') }}
                  <sup class="text-danger">*</sup>
                </label>
                <date-picker
                  v-model="birthday"
                  :format="$t('dateFormat')"
                  value-type="YYYY-MM-DD"
                  name="date"
                  :placeholder="$t('form.birthday')"
                  class="form-control form-control_date"
                  :class="{ 'is-invalid': errors.length }"
                  :lang="local"
                  id="birthday"
                ></date-picker>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="address"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="address">
                  {{ $t('form.address') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="address"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="address"
                  :placeholder="$t('form.address')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="zipCode"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="zipcode">
                  {{ $t('form.zipcode') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="zipCode"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="zipcode"
                  :placeholder="$t('form.zipcode')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <validation-provider
                name="city"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="city">
                  {{ $t('form.city') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="city"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="city"
                  :placeholder="$t('form.city')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <validation-provider
                name="country"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="country">
                  {{ $t('form.country') }}
                  <sup class="text-danger">*</sup>
                </label>
                <select
                  class="form-control p-0 pl-2"
                  v-model="country"
                  id="country"
                  :placeholder="$t('form.country')"
                  :class="{ 'is-invalid': errors.length }"
                >
                  <option></option>
                  <option
                    v-for="item in countries"
                    :value="{ name: item.name, id: item.id }"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <validation-provider
                name="local"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="local">
                  {{ $t('form.local') }}
                  <sup class="text-danger">*</sup>
                </label>
                <select
                  class="form-control p-0 pl-2"
                  v-model="local"
                  id="local"
                  :placeholder="$t('form.local')"
                  :class="{ 'is-invalid': errors.length }"
                >
                  <option value="fr">FR</option>
                  <option value="en">EN</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="password"
                rules="required|min:6"
                v-slot="{ errors }"
                vid="password"
              >
                <label for="signup-personal-password">
                  {{ $t('form.password') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="signup-personal-password"
                  :class="{ 'is-invalid': errors.length }"
                  :placeholder="$t('form.password')"
                />
                <span class="text-muted small">
                  {{ $t('form.passwordRule') }}</span
                >
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="confirmation"
                rules="required|confirmed:password"
                v-slot="{ errors }"
                vid="confirmation"
              >
                <label for="signup-personal-re-password">
                  {{ $t('form.confirmationPassword') }}
                  <sup class="text-danger">*</sup>
                </label>
                <input
                  v-model="confirmed"
                  type="password"
                  class="form-control"
                  id="signup-personal-re-password"
                  :class="{ 'is-invalid': errors.length }"
                  :placeholder="$t('form.password')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12">
            <div v-if="false" class="custom-control custom-checkbox">
              <input
                v-model="subscribe"
                type="checkbox"
                class="custom-control-input"
                id="check-10"
              />
              <label class="custom-control-label" for="check-10">
                {{ $t('form.subscriptionNewsletter') }}</label
              >
            </div>

            <div class="custom-control custom-checkbox mt-3">
              <validation-provider
                name="accepted"
                :rules="{ required: { allowFalse: false } }"
                v-slot="{ errors }"
              >
                <input
                  v-model="accepted"
                  type="checkbox"
                  :class="{ 'is-invalid': errors.length }"
                  class="custom-control-input"
                  id="check-20"
                />
                <label class="custom-control-label" for="check-20">
                  {{ $t('form.accept') }}
                  <sup class="text-danger">*</sup>
                </label>
              </validation-provider>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer d-flex justify-content-between pt-3">
        <div>
          <div
            v-if="monitor.visible"
            class="px-1 text-center"
            :class="monitor.type"
          >
            {{ monitor.message }}
          </div>
        </div>
        <button
          @click="store"
          class="btn btn-primary w-50 btn-icon-right d-flex justify-content-between"
          :disabled="invalid || isSaving"
        >
          {{ $t('signUp') }}
          <div class="icon icon-arrow-right_white"></div>
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as i18nIsoCountries from 'i18n-iso-countries'
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))
import { ValidationProvider, extend } from 'vee-validate'
export default {
  name: 'SignUpPersonal',
  components: {},
  data() {
    return {
      firstname: '',
      lastname: '',
      email: null,
      password: null,
      confirmed: null,
      phone: null,
      birthday: null,
      gender: 0,
      address: '',
      country: null,
      city: '',
      zipCode: '',
      subscribe: false,
      accepted: false,
      local: '',
      matchPassword: true,
      isSaving: false,
      countries: [],
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
  },
  created() {
    this.local = document.head.querySelector('meta[name="app-locale"]').content
    let countries = i18nIsoCountries.getNames(this.local, {
      select: 'official',
    })
    this.countries = Object.entries(countries).map(([key, value]) => ({
      id: key,
      name: value,
    }))
    // this.reset();
  },
  methods: {
    store() {
      let data = {}
      this.monitor.visible = false
      this.monitor.message = ''
      this.monitor.type = ''
      data.firstname = this.firstname
      data.lastname = this.lastname
      data.email = this.email
      data.phone = this.phone
      data.password = this.password
      data.password_confirmation = this.confirmed
      data.accepted = this.accepted
      data.address = this.address
      data.birthday = this.birthday
      data.gender = this.gender
      data.city = this.city
      data.zipcode = this.zipCode
      data.country = this.country.name
      data.country_code = this.country.id
      data.optin = this.subscribe
      data.local = this.local
      data.name = this.firstname + ' ' + this.lastname
      data.client_type = 1
      this.isSaving = true
      this.$store
        .dispatch('signUp', data)
        .then((response) => {
          if (response.status === 201) {
            this.monitor.type = 'text-success'
            this.monitor.visible = true
            this.monitor.message = this.$t('creatingAccountSuccessMsg')
            setTimeout(() => {
              this.monitor.visible = false
              this.monitor.message = ''
              let data = {}
              data.email = this.email
              data.password = this.password
              this.$store.dispatch('login', data)
              $('#signupModal').modal('hide')
              this.reset()
            }, 3000)
          }
        })
        .finally(() => {
          this.isSaving = false
        })
        .catch((error) => {
          this.monitor.visible = true
          if (error.response) {
            if (error.response.status == 400) {
              if (error.response.data.error.title.email) {
                this.monitor.type = 'text-danger'
                this.monitor.message = this.$t('errors.emailExist')
                this.email = null
                setTimeout(() => {
                  this.monitor.type = ''
                  this.monitor.message = ''
                  this.monitor.visible = false
                }, 3000)
              }
            } else {
              this.monitor.message = this.$t('errors.serverError')
              setTimeout(() => {
                this.monitor.type = ''
                this.monitor.message = ''
                this.monitor.visible = false
              }, 3000)
            }
          }
        })
    },
    reset() {
      this.$refs.form.reset()
      this.firstname = ''
      this.lastname = ''
      this.email = null
      this.password = null
      this.confirmed = null
      this.phone = null
      this.address = ''
      this.country = ''
      this.city = ''
      this.zipCode = ''
      this.birthday = null
      this.gender = 0
      this.subscribe = false
      this.accepted = false
    },
  },
  closeModal() {
    setTimeout(() => {
      this.monitor.visible = false
      this.monitor.message = ''
      $('#signupModal').modal('hide')
      this.reset()
    }, 1000)
  },
}
</script>

<style></style>
